import { Component } from '@angular/core';
import {IFloatingFilter, IFloatingFilterParams} from 'ag-grid-community';
import {FormControl} from "@angular/forms";

@Component({
  selector: 'dx-dictionary-floating-filter',
  templateUrl: './dx-dictionary-floating-filter.component.html',
  styleUrls: ['./dx-dictionary-floating-filter.component.css']
})
export class DxDictionaryFloatingFilterComponent implements  IFloatingFilter {

  constructor() { }

/*
  public cbOptions = {
    isSearchable: true,
    useServerSideModel: true,
    datasourceIdent: 'PIT_NCI_BACKEND_COMBO_DS',
    filter: new Map([['DICT_IDENT', 'user']])
  };
*/

  public cbPlanType: FormControl = new FormControl();

  agInit(params: IFloatingFilterParams): void {

  }

  onClick() {
    alert('Тут будет вызов фильтра');
  }

  onParentModelChanged(parentModel: any): void {

  }

}
